"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPoint = createPoint;
var _konva = _interopRequireDefault(require("konva"));
var _ = _interopRequireDefault(require(".."));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function createPoint(_ref) {
  var layer = _ref.layer,
    label = _ref.label,
    x = _ref.x,
    y = _ref.y,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "" : _ref$id,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? "" : _ref$name,
    _ref$onMouseEnter = _ref.onMouseEnter,
    onMouseEnter = _ref$onMouseEnter === void 0 ? null : _ref$onMouseEnter,
    _ref$onMouseLeave = _ref.onMouseLeave,
    onMouseLeave = _ref$onMouseLeave === void 0 ? null : _ref$onMouseLeave,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? true : _ref$interactive;
  var stage = layer.getParent();
  var handleCallback = function handleCallback(func, event) {
    if (typeof func === "function") func(event);
  };
  var group = new _konva.default.Group({
    draggable: false,
    id: id,
    name: "Point"
  });
  var circleMarker = new _konva.default.Circle({
    x: x,
    y: y,
    radius: 3,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    className: "circle"
  });

  // const stageRotaiton = stage.rotation();
  var cliRect = circleMarker.getClientRect();
  var position = {
    x: cliRect.x + cliRect.width / 2,
    y: cliRect.y + cliRect.height / 2
  };

  // marker value label
  _.default.label({
    parent: group,
    text: label,
    position: position,
    rotation: -stage.rotation(),
    offset: {
      x: 0,
      y: 25
    },
    center: true,
    fontSize: 15
  });

  // optional name label
  if (name) {
    _.default.label({
      parent: group,
      text: name,
      position: position,
      rotation: -stage.rotation(),
      offset: {
        x: 15,
        y: 15
      },
      center: true,
      fontSize: 15
    });
  }
  if (interactive !== true) {
    group.on("mouseenter", function (e) {
      handleCallback(onMouseEnter, e);
    });
    group.on("mouseleave", function (e) {
      handleCallback(onMouseLeave, e);
    });
    group.on("click", function (e) {
      handleCallback(onClick, e);
    });
  }

  // add to group and to layer
  group.add(circleMarker);
  layer.add(group);
}